import { ConditionDesigner } from "../../editors/ConditionDesigner";
import type { groupConditionBuilder } from "./groupConditionBuilder";

export const GroupConditionSummary: typeof groupConditionBuilder.views.summary = ({
  config: { operator },
  children: { values },
}) => (
  <div>
    {values.length ? (
      <>
        <p>{operator} of</p>
        <ul>
          {values.map((v) => (
            <li key={v.id}>
              <ConditionDesigner condition={v} view="summary" />
            </li>
          ))}
        </ul>
      </>
    ) : (
      <div>Condition Group</div>
    )}
  </div>
);
